import { StyledDrawer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles.ts';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { DataCustomDetailTct } from '@dealstack/shared/lib/generated';
import { ENTITY_TABS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/types.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useCreateCustomFieldDrawer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/components/CreateCustomFIle/useCreateCustomFieldDrawer.ts';
import { CustomFieldFormBody } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/components/CreateCustomFIle/CustomFieldFormBody';

interface Props {
	opened: boolean;
	onClose: () => void;
	activeTab: ENTITY_TABS;
	editField?: DataCustomDetailTct | null;
	mipId?: string;
}

export const CreateCustomFieldDrawer = ({
	opened,
	onClose,
	activeTab,
	editField,
	mipId,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	const { createCustomFieldForm, onSubmit, handleDelete, isLoading } = useCreateCustomFieldDrawer(
		onClose,
		activeTab,
		editField,
		mipId
	);

	const isEditMode = !!editField;

	return (
		<StyledDrawer
			opened={opened}
			onClose={onClose}
			position="right"
			transitionProps={drawerTransitionProps}
			trapFocus={false}
			title={
				isEditMode
					? tMipManage('investor_data.custom_fields.edit_field')
					: tMipManage('investor_data.custom_fields.add_field')
			}
		>
			<CustomFieldFormBody
				form={createCustomFieldForm}
				isEditMode={isEditMode}
				isLoading={isLoading}
				onSubmit={onSubmit()}
				onDelete={handleDelete}
			/>
		</StyledDrawer>
	);
};
